module.exports = __webpack_public_path__ + "img/360.7b119ed6.svg";